module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Light-Italic.f9f979e1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Light-Italic.eot
// module id = 2199
// module chunks = 50